import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import greenArrow from '../../assets/images/green-arrow.svg';
import successIcon from '../../assets/images/success-icon.svg';
import * as Yup from "yup";
import { baseUrl } from '../../utils/baseUrl';
import axios from 'axios';
import { getLocalStorageItem } from '../../utils/localStorage';
import * as toast from '../../utils/makeToast'
import { useNavigate } from 'react-router';
import Select from 'react-select'
import { data } from 'jquery';
import { encryptRequest } from '../../utils/encryption';


function AddReferenceCurrentDialog(props: any) {

    const navigate = useNavigate()

    const formik = useFormik({
        initialValues: {
            accountNumber: '',
            refereeEmail: ''
        },
        validationSchema: Yup.object({
            accountNumber: Yup.string().required("Account number is required").length(10),
        }),
        onSubmit: (values) => {
            validateAccountNumber(values)
        }
    })


    const [showBankOptions, setShowBankOptions] = useState<boolean>(false)
    const [screenToShow, setScreenToShow] = useState('step-one')

    const [selectedBank, setSelectedBank] = useState<any>()
    const [mappedBanks, setMappedBanks] = useState([]);

    const [userDetails, setUserDetails] = useState(getLocalStorageItem('userDetails'))
    const [accountType, setAccountType] = useState(localStorage.getItem('altFinanceAccountType'))

    const [userExistingDetails, setUserExistingDetails] = useState<any>()

    const [updatingReferee, setUpdatingReferee] = useState<boolean>(false)

    const [isSterlingReferee, setIsSterlingReferee] = useState<boolean>(false)

    const [accountHolderName, setAccountHolderName] = useState('')
    const [verifyingAccount, setVerifyingAccount] = useState<boolean>(false)
    const [isAccountNumberValid, setIsAccountNumberValid] = useState<boolean>(false)

    const goToHomePage = () => {
        navigate("/personal-account")
    }

    const addSecondReference = () => {
        setScreenToShow('step-one')
        formik.values.accountNumber = ''
    }

    const changeReferee = () => {
        setScreenToShow('step-one')
        formik.values.accountNumber = ''
    }

    const validateAccountNumber = (values: any) => {
        setShowBankOptions(true)
    }

    const goToSterlingStepOne = () => {
        setIsSterlingReferee(true)
        setScreenToShow('step-two')
        validateSterlingAccountNumber(formik.values.accountNumber)
    }

    const goToOtherBanks = () => {
        setIsSterlingReferee(false)
        setScreenToShow('step-two')
    }

    const getBanks = () => {
        axios.get(`${baseUrl}Enum/BanksList`)
            .then((response) => {
                let tempBanks = response.data?.obj
                tempBanks = response.data?.obj.map((bank) => {
                    return {
                        label: bank.bankName,
                        value: bank.bankCode
                    }
                })
                setMappedBanks(tempBanks)
            })
            .catch((err) => {
            })
    }

    const handleSelectBank = (data:any) => {
        setSelectedBank(data);
    }

    useEffect(() => {
        validateNonSterlingAccountNumber(formik.values.accountNumber)
    }, [selectedBank])

    const getExistingDetails = () => {
        let urlSuffix = ''

        switch (accountType?.toLowerCase()) {
            case 'savings':
                urlSuffix = 'SavingsAccount/existingDetails?bvn=';
                break;
            case 'minor savings':
                urlSuffix = 'MinorSavings/existingDetails?bvn=';
                break;
            case 'joint savings':
                urlSuffix = 'JointSavings/existingDetails?bvn=';
                break;
            case 'domiciliary savings':
                urlSuffix = 'DomiciliarySavings/existingDetails?bvn=';
                break;
            case 'current':
                urlSuffix = 'CurrentAccount/CurrentExistingDetails?Bvn=';
                break;
            case 'joint current':
                urlSuffix = 'JointCurrent/JointCurrentExistingDetails?Bvn=';
                break;
            case 'domiciliary current':
                urlSuffix = 'DomiciliaryCurrent/DomiciliaryCurrentExistingDetails?Bvn=';
                break;
            default:
        }


        axios.get(`${baseUrl}${urlSuffix}${encryptRequest(userDetails.bvn)}`)
            .then((response) => {
                setUserExistingDetails(response?.data)
                let userData = response?.data
            })
            .catch((err) => {
            })
    }

    const validateSterlingAccountNumber = (accountNumber: string): any => {
        setVerifyingAccount(true)
        axios.get(`${baseUrl}Authentication/ValidationAccountNumber?accountnumber=${encryptRequest(accountNumber)}`)
            .then((response) => {
                if(response.data.getAccounts.accounT_NO){
                    setAccountHolderName(response.data.getAccounts.acC_NAME)
                    setIsAccountNumberValid(true)
                    return true
                }
                else{
                    toast.errorToast('Invalid account number')
                    setIsAccountNumberValid(false)
                    return false
                }
            })
            .catch((err) => {
                setIsAccountNumberValid(false)
                toast.errorToast(err?.response?.data?.title ? err?.response?.data?.title : err?.response?.data?.message)
                return false
            })
            .finally(() => setVerifyingAccount(false))
    }

    const validateNonSterlingAccountNumber = (accountNumber: string): any => {
        if(!isSterlingReferee && accountNumber.length === 10){
            setVerifyingAccount(true)
            let payload = {
                destinationInstitutionCode: selectedBank.value,
                accountNumber
            }
            axios.post(`${baseUrl}Authentication/NameEnquiry`, payload)
                .then((response) => {
                    if(response.data.isSuccess) {
                        setAccountHolderName(response.data?.obj.nameDetails)
                        setIsAccountNumberValid(true)
                    }
                })
                .catch((err) => {
                    setIsAccountNumberValid(false)
                    toast.errorToast(err?.response?.data?.title ? err?.response?.data?.title : err?.response?.data?.message)
                })
                .finally(() => setVerifyingAccount(false))
        }
    }

    const checkSterlingAccountNumberLength = (e:any) => {
        if(e.target.value.length === 10){
            if(isSterlingReferee){
                validateSterlingAccountNumber(e.target.value)
            }
            else{
                validateNonSterlingAccountNumber(e.target.value)
            }
        }
    }

    const getSterlingBankCode = () => {
        return mappedBanks.find(x => x?.label?.toLowerCase() === 'sterling bank')?.value || ''
    }

    const validateEmail = (email) => 
    {
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email))
    {
        return (true)
    }
        return (false)
    }


    const submitReferee = (accountNumber: string, refereeEmail: string) => {
        if (!accountNumber) {
            toast.errorToast('Please provide account number')
            return
        }
        if (accountNumber.length !== 10) {
            toast.errorToast('Invalid account number')
            return
        }
        if (!refereeEmail){
            toast.errorToast('Please provide referee email')
            return
        }
        if (!validateEmail(refereeEmail)){
            toast.errorToast('Invalid email')
            return
        }
        setUpdatingReferee(true)
        let refereePayload = {
            refereeAccountNumber: accountNumber,
            refereeAccountName: accountHolderName,
            refereeBankCode:  isSterlingReferee ? getSterlingBankCode() : selectedBank?.value,
            refereeFormUrl: "",
            refereeEmail: refereeEmail,
            Bvn: userExistingDetails?.bvn,
            id: userExistingDetails?.id
        }
        let urlSuffix = ''
        switch (accountType?.toLowerCase()) {
            case 'domiciliary savings':
                urlSuffix = 'DomiciliarySavings/referee';
                break;
            case 'current':
                urlSuffix = 'CurrentAccount/CurrentReferee';
                break;
            case 'joint current':
                urlSuffix = 'JointCurrent/JointReferee';
                break;
            case 'domiciliary current':
                urlSuffix = 'DomiciliaryCurrent/DomiciliaryReferee';
                break;

            default:
        }

        // return

        axios.post(`${baseUrl}${urlSuffix}`, refereePayload)
            .then((response) => {
                setUpdatingReferee(false)
                // REFACTOR CODE TO OPEN MODAL
                document.getElementById('show-modal-btn')?.click()
            })
            .catch((err) => {
                setUpdatingReferee(false)
                toast.errorToast(err?.response?.data?.title ? err?.response?.data?.title : err?.response?.data?.message)
            })
    }

    useEffect(() => {
        getBanks()
        getExistingDetails()
    }, [])


    return (
        <div>
            <form onSubmit={formik.handleSubmit}>
                {screenToShow === 'step-one' ?
                    <div>
                        <div className="p-4">
                            <h4 className=" small-bold-texts font-weight-bold text-center mt-1">Add Reference</h4>
                            <p className="text-center mt-3 mb-4 text-secondary">
                                Proceed to add reference, kindly ensure that the referee's <br />
                                account meets the following requirements:</p>
                            <div className="row mx-auto text-secondary">
                                <article className="px-0 mt-0">
                                    <div className="text-lg-left py-2">
                                        <span className="bullets mr-1" style={{ marginRight: '10px' }}></span>
                                        <span>Account has been in operation for more than 6 months</span>
                                    </div>
                                </article>
                                <article className=" px-0 mt-0">
                                    <div className=" text-lg-left py-1">
                                        <span className="bullets mr-1" style={{ marginRight: '10px' }}></span>
                                        <span>Account is not dormant</span>
                                    </div>
                                </article>
                                <article className=" px-0 mt-0">
                                    <div className=" text-lg-left py-1">
                                        <span className="bullets mr-1" style={{ marginRight: '10px' }}></span>
                                        <span>Category criteria (References from an Individual account can only be used
                                            <span className="ml-md-3">for an Individual account but a reference from a registered business is </span>
                                            <span className="ml-md-3">suitable for all forms of current accounts).</span></span>
                                    </div>
                                </article>
                            </div>
                            
                            <div className=" form-group ">
                                <div className=" label_text pb-2 pt-4 text-left mb-1"> <label htmlFor="button">Referee's account number</label></div>
                                <input name="accountNumber" onChange={formik.handleChange} value={formik.values.accountNumber} type="text" className="form-control border-dark py-4" placeholder="Enter your referee's account number" />
                                {formik.touched.accountNumber && formik.errors.accountNumber ? <small className="text-danger">{formik.errors.accountNumber}</small> : null}
                            </div>

                            <div className="d-flex justify-content-lg-end mt-4 align-items-center duo-buttons">
                                <button className="btn btn-filled-red" id="ValidationTriggered">Validate</button>
                            </div>


                            {showBankOptions ?
                                <div className="label_text pb-2 pt-4" id="validationCompleted">
                                    <label htmlFor="">Select Bank</label>
                                    <div className="duo-buttons2 row mt-4 mx-auto">
                                        <div className="col-md-5 div-buttons btn small-bold-texts" onClick={goToSterlingStepOne}>
                                            Sterling bank</div>
                                        <div className=" col-md-5 div-buttons btn small-bold-texts" id="OtherBanksButton" onClick={goToOtherBanks}>
                                            Other bank</div>
                                    </div>
                                </div>
                                : ''}

                        </div>
                    </div>
                    : ''}

                {/* ------- */}

                {screenToShow === 'step-two' ?
                    <div className="p-4">
                        <h4 className=" small-bold-texts font-weight-bold text-center mt-1">Add Reference</h4>
                        <div className=" form-group sec ">
                            <div className=" label_text pb-2 pt-4 text-left mb-1"> <label htmlFor="button">Referee's account number</label></div>
                            <input name="accountNumber" onInput={checkSterlingAccountNumberLength} onChange={formik.handleChange} value={formik.values.accountNumber} type="text" className="form-control border-dark" placeholder="1234567890" />
                            { verifyingAccount ? <small>verifying...</small> : <small>{accountHolderName}</small>}
                            
                        </div>
                        <div className=" form-group sec ">
                            <div className=" label_text pb-2 pt-4 text-left mb-1"> <label htmlFor="button">Select Bank</label></div>
                            {
                                isSterlingReferee ? 
                                <input type="text" className="form-control border-dark" placeholder="Sterling Bank" disabled /> :
                                <Select 
                                    options={mappedBanks} 
                                    value={selectedBank}
                                    onChange={handleSelectBank}
                                />
                            }
                        </div>

                        <div className=" form-group sec ">
                            <div className=" label_text pb-2 pt-4 text-left mb-1"> <label htmlFor="button">Referee's email address</label></div>
                            <input name="refereeEmail" onChange={formik.handleChange} value={formik.values.refereeEmail} type="text" className="form-control border-dark" placeholder="johndoe@gmail.com" />
                        </div>

                        <div className="row mx-auto text-secondary mt-5">
                            <article className="px-0 mt-0">
                                <div className="text-lg-left py-2">
                                    <span className="marker mr-1" style={{ marginRight: '10px' }}><img src={greenArrow} alt="checked" /></span>
                                    <span>Account has been in operation for more than 6 months</span>
                                </div>
                            </article>
                            <article className=" px-0 mt-0">
                                <div className=" text-lg-left py-1">
                                    <span className="marker mr-1" style={{ marginRight: '10px' }}><img src={greenArrow} alt="checked" /></span>
                                    <span>Account is not dormant</span>
                                </div>
                            </article>
                            <article className=" px-0 mt-0">
                                <div className=" text-lg-left py-1">
                                    <span className="marker mr-1" style={{ marginRight: '10px' }}><img src={greenArrow} alt="checked" /></span>
                                    <span>Category criteria (References from an Individual account can only be used
                                        <span className="ml-md-3">for an Individual account but a reference from a registered business is </span>
                                        <span className="ml-md-3">suitable for all forms of current accounts).</span></span>
                                </div>
                            </article>
                        </div>

                        <div className="d-flex justify-content-end mt-4">
                            <div className="mb-3 mr-4" style={{ marginRight: '20px' }}>
                                <button type='button' onClick={changeReferee} className="btn btn-outline-gold mr-3 btn-filled-white">Change Referee</button>
                            </div>

                            {updatingReferee ?
                                <div className="spinner-border text-danger" role="status">
                                    <span className="sr-only"></span>
                                </div> :
                                <button type="button" disabled={!isAccountNumberValid && mappedBanks.length > 0} onClick={() => submitReferee(formik.values.accountNumber, formik.values.refereeEmail)} className="btn btn-filled-red">Proceed</button>
                            }
                        </div>

                    </div>

                    : ''}

                <button type="button" id="show-modal-btn" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#reference-Added1" data-bs-whatever="@mdo">Open modal for @mdo</button>

            </form>
            {/* ----------- */}


            {/* ----------- */}
            <div className="modal fade reference-addedModal" id="reference-Added1"
                aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body p-5">
                            <div className="d-flex justify-content-center">
                                <img src={successIcon} alt="success notification" />
                            </div>
                            <div className="text-center mt-3">
                                <p className="text-center medium-bold-texts m-2">Reference added successfully</p>
                            </div>
                            <p className="text-center mt-3 mb-4 text-secondary">
                                We have contacted your Sterling Referee, and we await their consent <br />
                                You will be notified if no response is received within 24hr.</p>
                            <p className="text-center mt-3 mb-4 text-secondary">
                                Confirmation commences immediately after consent has been received <br />
                                and is completed within 1 -2 working days. <br /> You will be notified of the outcome. </p>

                            <div className="mt-5 d-flex justify-content-center">
                                <button style={{ marginRight: '20px' }} type="button" className="btn btn-outline-gold mr-3 btn-filled-white"
                                    data-bs-dismiss="modal" aria-label="Close" onClick={goToHomePage}
                                >okay</button>
                                <button type="button" className="btn btn-danger btn-filled-red2"
                                    data-bs-dismiss="modal" aria-label="Close" onClick={addSecondReference}
                                >Add second reference</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* ----------- */}
        </div>
    );
}

export default AddReferenceCurrentDialog;




// import { useFormik } from 'formik';
// import React, { useEffect, useState } from 'react';
// import cautionAlert from '../../assets/images/caution-alert.svg';
// import greenArrow from '../../assets/images/green-arrow.svg';
// import successIcon from '../../assets/images/success-icon.svg';
// import downloadIcon from '../../assets/images/download-icon.svg';
// import whatsappIcon from '../../assets/images/whatsapp-icon.svg';
// import mailIcon from '../../assets/images/mail-icon.svg';
// import uploadIcon from '../../assets/images/upload-icon.svg';
// import * as Yup from "yup";
// import { baseUrl } from '../../utils/baseUrl';
// import axios from 'axios';
// import { getLocalStorageItem } from '../../utils/localStorage';
// import * as toast from '../../utils/makeToast'
// import { useNavigate } from 'react-router';
// import Select from 'react-select'




// function AddReferenceCurrentDialog(props: any) {



//     const navigate = useNavigate()

//     const formik = useFormik({
//         initialValues: {
//             accountNumber: '',
//             sterlingAccountNumber: '',
//             otherBank: ''
//         },
//         validationSchema: Yup.object({
//             accountNumber: Yup.string().required("Account number is required").length(10),
//         }),
//         onSubmit: (values) => {
//             validateAccountNumber(values)
//         }
//     })


//     const [showBankOptions, setShowBankOptions] = useState<boolean>(false)
//     const [showOtherBanks, setShowOtherBanks] = useState<boolean>(false)
//     const [screenToShow, setScreenToShow] = useState('step-one')

//     const [banks, setBanks] = useState<any[]>([])

//     const [selectedBank, setSelectedBank] = useState<any>()
//     const [mappedBanks, setMappedBanks] = useState([]);

//     const [userDetails, setUserDetails] = useState(getLocalStorageItem('userDetails'))
//     const [accountType, setAccountType] = useState(localStorage.getItem('altFinanceAccountType'))

//     const [userExistingDetails, setUserExistingDetails] = useState<any>()

//     const [updatingSterlingReferee, setUpdatingSterlingReferee] = useState<boolean>(false)
//     const [updatingOtherBankReferee, setUpdatingOtherBankReferee] = useState<boolean>(false)

//     const [updatingReferee, setUpdatingReferee] = useState<boolean>(false)


//     const [referenceFormUrl, setReferenceFormUrl] = useState('')
//     const [referenceFormName, setReferenceFormName] = useState('')
//     const [settingReferenceForm, setSettingReferenceForm] = useState<boolean>(false)

//     // const [sterlingAccountHolderName, setSterlingAccountHolderName] = useState('')
//     // const [verifyingSterlingAccount, setVerifyingSterlingAccount] = useState<boolean>(false)
//     // const [isSterlingAccountNumberValid, setIsSterlingAccountNumberValid] = useState<boolean>(false)

//     const [isSterlingReferee, setIsSterlingReferee] = useState<boolean>(false)

//     const [accountHolderName, setAccountHolderName] = useState('')
//     const [verifyingAccount, setVerifyingAccount] = useState<boolean>(false)
//     const [isAccountNumberValid, setIsAccountNumberValid] = useState<boolean>(false)

//     let fileUploadObj: any


//     const goToHomePage = () => {
//         navigate("/personal-account")
//     }

//     const addSecondReference = () => {
//         setScreenToShow('step-one')
//         formik.values.accountNumber = ''
//         formik.values.sterlingAccountNumber = ''
//     }

//     const validateAccountNumber = (values: any) => {
//         setShowBankOptions(true)
//     }

//     const goToSterlingStepOne = () => {
//         setIsSterlingReferee(true)
//         setScreenToShow('sterling-step-one')
//     }

//     const goToOtherBanks = () => {
//         // setShowOtherBanks(true)
//         setIsSterlingReferee(false)
//         setScreenToShow('sterling-step-one')
//     }

//     const goToOtherBankReference = () => {
//         // setScreenToShow('other-bank-step-one')
//         setScreenToShow('sterling-step-one')
//     }

//     const getBanks = () => {
//         axios.get(`${baseUrl}Enum/BanksList`)
//             .then((response) => {
//                 setBanks(response.data?.obj)
//                 let tempBanks = response.data?.obj
//                 tempBanks = response.data?.obj.map((bank) => {
//                     return {
//                         label: bank.bankName,
//                         value: bank.bankCode
//                     }
//                 })
//                 setMappedBanks(tempBanks)
//             })
//             .catch((err) => {
//             })
//     }

//     const handleSelectBank = (data:any) => {
//         setSelectedBank(data);
//     }

//     const uploadImage = (payload: any, type: string) => {
//         setSettingReferenceForm(true)
//         axios.post(`${baseUrl}Authentication/UploadFile`, payload)
//             .then((response) => {
//                 setReferenceFormUrl(response.data?.id)
//                 setSettingReferenceForm(false)
//             })
//             .catch((err) => {
//                 setSettingReferenceForm(false)
//                 toast.errorToast(err?.response?.data?.title ? err?.response?.data?.title : err?.response?.data?.message)
//             })
//     };

//     const handleSubmit = (type: string) => {
//         uploadImage(fileUploadObj, type);
//     };

//     const convertToBase64 = (file: any) => {
//         return new Promise((resolve, reject) => {
//             const fileReader = new FileReader();
//             fileReader.readAsDataURL(file);
//             fileReader.onload = () => {
//                 let fileReaderResult = fileReader.result?.toString()
//                 if (
//                     fileReader.result?.toString().substring(0, 25).split('/')[1].split(';')[0] === 'png' ||
//                     fileReader.result?.toString().substring(0, 25).split('/')[1].split(';')[0] === 'jpg' ||
//                     fileReader.result?.toString().substring(0, 25).split('/')[1].split(';')[0] === 'pdf'
//                 ) {
//                     return resolve(fileReaderResult?.substring(22))
//                 }
//                 else if (
//                     fileReader.result?.toString().substring(0, 25).split('/')[1].split(';')[0] === 'jpeg'
//                 ) {
//                     return resolve(fileReaderResult?.substring(23))
//                 }
//                 // resolve(fileReader.result);
//             };
//             fileReader.onerror = (error) => {
//                 reject(error);
//             };
//         });
//     };

//     const handleFileUpload = async (e: any, type: string) => {
//         const file = e.target.files[0];
//         setReferenceFormName(file.name)
//         let base64: any;

//         convertToBase64(file)
//             .then(res => {
//                 // (res)
//                 base64 = res
//                 fileUploadObj = {
//                     postedFilebase64: res,
//                     documentName: type,
//                     filetype: file.type.split('/')[1]
//                 }
//                 handleSubmit(type)
//             })


//     };

//     const getExistingDetails = () => {
//         let urlSuffix = ''

//         switch (accountType?.toLowerCase()) {
//             case 'savings':
//                 urlSuffix = 'SavingsAccount/existingDetails?bvn=';
//                 break;
//             case 'minor savings':
//                 urlSuffix = 'MinorSavings/existingDetails?bvn=';
//                 break;
//             case 'joint savings':
//                 urlSuffix = 'JointSavings/existingDetails?bvn=';
//                 break;
//             case 'domiciliary savings':
//                 urlSuffix = 'DomiciliarySavings/existingDetails?bvn=';
//                 break;
//             case 'current':
//                 urlSuffix = 'CurrentAccount/CurrentExistingDetails?Bvn=';
//                 break;
//             case 'joint current':
//                 urlSuffix = 'JointCurrent/JointCurrentExistingDetails?Bvn=';
//                 break;
//             case 'domiciliary current':
//                 urlSuffix = 'DomiciliaryCurrent/DomiciliaryCurrentExistingDetails?Bvn=';
//                 break;

//             default:
//             // 
//         }


//         axios.get(`${baseUrl}${urlSuffix}${userDetails.bvn}`)
//             .then((response) => {
//                 setUserExistingDetails(response?.data)
//                 let userData = response?.data
//             })
//             .catch((err) => {
//             })
//     }

//     // const validateSterlingAccountNumber = (accountNumber: string): any => {
//     //     setVerifyingSterlingAccount(true)
//     //     axios.get(`${baseUrl}Authentication/ValidationAccountNumber?accountnumber=${accountNumber}`)
//     //         .then((response) => {
//     //             if(response.data.getAccounts.accounT_NO){
//     //                 setSterlingAccountHolderName(response.data.getAccounts.acC_NAME)
//     //                 setIsSterlingAccountNumberValid(true)
//     //                 return true
//     //             }
//     //             else{
//     //                 toast.errorToast('Invalid account number')
//     //                 setIsSterlingAccountNumberValid(false)
//     //                 return false
//     //             }
//     //         })
//     //         .catch((err) => {
//     //             setIsSterlingAccountNumberValid(false)
//     //             toast.errorToast(err?.response?.data?.title ? err?.response?.data?.title : err?.response?.data?.message)
//     //             return false
//     //         })
//     //         .finally(() => setVerifyingSterlingAccount(false))
//     // }

//     const validateRefereeAccountNumber = (accountNumber: string): any => {
//         setVerifyingAccount(true)
//         axios.get(`${baseUrl}Authentication/ValidationAccountNumber?accountnumber=${accountNumber}`)
//             .then((response) => {
//                 if(response.data.getAccounts.accounT_NO){
//                     setAccountHolderName(response.data.getAccounts.acC_NAME)
//                     setIsAccountNumberValid(true)
//                     return true
//                 }
//                 else{
//                     toast.errorToast('Invalid account number')
//                     setIsAccountNumberValid(false)
//                     return false
//                 }
//             })
//             .catch((err) => {
//                 setIsAccountNumberValid(false)
//                 toast.errorToast(err?.response?.data?.title ? err?.response?.data?.title : err?.response?.data?.message)
//                 return false
//             })
//             .finally(() => setVerifyingAccount(false))
//     }

//     const checkSterlingAccountNumberLength = (e:any) => {
//         if(e.target.value.length === 10){
//             validateRefereeAccountNumber(e.target.value)
//         }
//     }

//     const submitReferee = (accountNumber: string) => {
//         if (!accountNumber) {
//             toast.errorToast('Please provide account number')
//             return
//         }
//         if (accountNumber.length !== 10) {
//             toast.errorToast('Invalid account number')
//             return
//         }
//         setUpdatingSterlingReferee(true)
//         let sterlingRefereePayload = {
//             refereeAccountNumber: accountNumber,
//             refereeAccountName: "",
//             refereeBankCode: selectedBank?.value,
//             refereeFormUrl: "",
//             id: userExistingDetails?.id
//         }
//         let urlSuffix = ''
//         switch (accountType?.toLowerCase()) {
//             case 'domiciliary savings':
//                 urlSuffix = 'DomiciliarySavings/referee';
//                 break;
//             case 'current':
//                 urlSuffix = 'CurrentAccount/CurrentReferee';
//                 break;
//             case 'joint current':
//                 urlSuffix = 'JointCurrent/JointReferee';
//                 break;
//             case 'domiciliary current':
//                 urlSuffix = 'DomiciliaryCurrent/DomiciliaryReferee';
//                 break;

//             default:
//         }
//         (urlSuffix)
//         (sterlingRefereePayload)

//         return

//         axios.post(`${baseUrl}${urlSuffix}`, sterlingRefereePayload)
//             .then((response) => {
//                 (response)
//                 setUpdatingSterlingReferee(false)
//                 // REFACTOR CODE TO OPEN MODAL
//                 document.getElementById('show-modal-btn')?.click()
//             })
//             .catch((err) => {
//                 setUpdatingSterlingReferee(false)
//                 toast.errorToast(err?.response?.data?.title ? err?.response?.data?.title : err?.response?.data?.message)
//             })
//     }


//     const submitSterlingReferee = (accountNumber: string) => {
//         if (!accountNumber) {
//             toast.errorToast('Please provide account number')
//             return
//         }
//         if (accountNumber.length !== 10) {
//             toast.errorToast('Invalid account number')
//             return
//         }
//         setUpdatingSterlingReferee(true)
//         // let sterlingRefereePayload = {
//         //     refereeAccountNumber: accountNumber,
//         //     refereeFormUrl: '',
//         //     id: userExistingDetails?.id
//         // }
//         let sterlingRefereePayload = {
//             refereeAccountNumber: accountNumber,
//             refereeAccountName: "",
//             refereeBankCode: selectedBank?.value,
//             refereeFormUrl: "",
//             id: userExistingDetails?.id
//         }
//         let urlSuffix = ''
//         switch (accountType?.toLowerCase()) {
//             case 'domiciliary savings':
//                 urlSuffix = 'DomiciliarySavings/referee';
//                 break;
//             case 'current':
//                 urlSuffix = 'CurrentAccount/CurrentReferee';
//                 break;
//             case 'joint current':
//                 urlSuffix = 'JointCurrent/JointReferee';
//                 break;
//             case 'domiciliary current':
//                 urlSuffix = 'DomiciliaryCurrent/DomiciliaryReferee';
//                 break;

//             default:
//             // 
//         }
//         (urlSuffix)
//         (sterlingRefereePayload)

//         return

//         axios.post(`${baseUrl}${urlSuffix}`, sterlingRefereePayload)
//             .then((response) => {
//                 (response)
//                 setUpdatingSterlingReferee(false)
//                 // REFACTOR CODE TO OPEN MODAL
//                 document.getElementById('show-modal-btn')?.click()
//             })
//             .catch((err) => {
//                 setUpdatingSterlingReferee(false)
//                 toast.errorToast(err?.response?.data?.title ? err?.response?.data?.title : err?.response?.data?.message)
//             })
//     }

//     const submitOtherBankReferee = () => {
//         setUpdatingOtherBankReferee(true)
//         let otherBankRefereePayload = {
//             refereeAccountNumber: '',
//             refereeFormUrl: referenceFormUrl,
//             id: userExistingDetails?.id
//         }
//         let urlSuffix = ''
//         switch (accountType?.toLowerCase()) {
//             case 'domiciliary savings':
//                 urlSuffix = 'DomiciliarySavings/referee';
//                 break;
//             case 'current':
//                 urlSuffix = 'CurrentAccount/CurrentReferee';
//                 break;
//             case 'joint current':
//                 urlSuffix = 'JointCurrent/JointReferee';
//                 break;
//             case 'domiciliary current':
//                 urlSuffix = 'DomiciliaryCurrent/DomiciliaryReferee';
//                 break;

//             default:
//             // 
//         }
//         (urlSuffix)
//         (otherBankRefereePayload)

//         // return

//         axios.post(`${baseUrl}${urlSuffix}`, otherBankRefereePayload)
//             .then((response) => {
//                 (response)
//                 setUpdatingOtherBankReferee(false)
//                 // REFACTOR CODE TO OPEN MODAL
//                 document.getElementById('show-modal-btn')?.click()
//             })
//             .catch((err) => {
//                 setUpdatingOtherBankReferee(false)
//                 toast.errorToast(err?.response?.data?.title ? err?.response?.data?.title : err?.response?.data?.message)
//             })
//     }



//     useEffect(() => {
//         getBanks()
//         getExistingDetails()
//     }, [])


//     return (
//         <div>
//             <form onSubmit={formik.handleSubmit}>
//                 {screenToShow === 'step-one' ?
//                     <div>
//                         <div className="p-4">
//                             <h4 className=" small-bold-texts font-weight-bold text-center mt-1">Add Reference</h4>
//                             <p className="text-center mt-3 mb-4 text-secondary">
//                                 Proceed to add reference, kindly ensure that the referee's <br />
//                                 account meets the following requirements:</p>
//                             <div className="row mx-auto text-secondary">
//                                 <article className="px-0 mt-0">
//                                     <div className="text-lg-left py-2">
//                                         <span className="bullets mr-1" style={{ marginRight: '10px' }}></span>
//                                         <span>Account has been in operation for more than 6 months</span>
//                                     </div>
//                                 </article>
//                                 <article className=" px-0 mt-0">
//                                     <div className=" text-lg-left py-1">
//                                         <span className="bullets mr-1" style={{ marginRight: '10px' }}></span>
//                                         <span>Account is not dormant</span>
//                                     </div>
//                                 </article>
//                                 <article className=" px-0 mt-0">
//                                     <div className=" text-lg-left py-1">
//                                         <span className="bullets mr-1" style={{ marginRight: '10px' }}></span>
//                                         <span>Category criteria (References from an Individual account can only be used
//                                             <span className="ml-md-3">for an Individual account but a reference from a registered business is </span>
//                                             <span className="ml-md-3">suitable for all forms of current accounts).</span></span>
//                                     </div>
//                                 </article>
//                             </div>
//                             {/* <div className="mt-4  addRef-cautions row mx-auto">
//                                 <div className="col-md-2 d-flex justify-content-center">
//                                     <img src={cautionAlert} alt="caution-alert" />
//                                 </div>
//                                 <div className="col-md">
//                                     <div className=" pt-3 pb-0">
//                                         <span className="small-bullets mr-1" style={{ marginRight: '10px' }}></span>
//                                         <span>For referee with Sterling account, an email is sent to the referee to provide
//                                             consent via a secured link.</span>
//                                     </div>
//                                     <div className="pt-2 pb-2">
//                                         <span className="small-bullets mr-1" style={{ marginRight: '10px' }}></span>
//                                         <span>For referee with other bank account, download or email form to referee and
//                                             upload the completed form.</span>
//                                     </div>
//                                 </div>
//                             </div> */}
//                             <div className=" form-group ">
//                                 <div className=" label_text pb-2 pt-4 text-left mb-1"> <label htmlFor="button">Referee's account number</label></div>
//                                 <input name="accountNumber" onChange={formik.handleChange} value={formik.values.accountNumber} type="text" className="form-control border-dark py-4" placeholder="Enter your referee's account number" />
//                                 {formik.touched.accountNumber && formik.errors.accountNumber ? <small className="text-danger">{formik.errors.accountNumber}</small> : null}
//                             </div>

//                             <div className="d-flex justify-content-lg-end mt-4 align-items-center duo-buttons">
//                                 {/* <button type="submit" className="btn btn-danger btn-filled-red" id="ValidationTriggered">Validate</button> */}
//                                 <button type="submit" className="btn btn-danger btn-filled-red" id="ValidationTriggered">Validate</button>
//                             </div>


//                             {showBankOptions ?
//                                 <div className="label_text pb-2 pt-4" id="validationCompleted">
//                                     <label htmlFor="">Select Bank</label>
//                                     <div className="duo-buttons2 row mt-4 mx-auto">
//                                         <div className="col-md-5 div-buttons btn small-bold-texts" onClick={goToSterlingStepOne}>
//                                             Sterling bank</div>
//                                         <div className=" col-md-5 div-buttons btn small-bold-texts" id="OtherBanksButton" onClick={goToOtherBanks}>
//                                             Other bank</div>
//                                     </div>
//                                 </div>
//                                 : ''}


//                             {showOtherBanks ?
//                                 <div className="mt-4" id="otherBanksMenu">

//                                     <div className="select-group ">

//                                         <div className=" label_text pb-2 pt-1 text-left mb-1"> <label htmlFor="button">Select other bank</label></div>

//                                         <div className=" row d-flex form-group mb-4">
//                                             {/* <select name="otherBank" onChange={formik.handleChange} value={formik.values.otherBank} className="form-control border-dark bg-white" id="">
//                                                 <option value="">Select Bank</option>
//                                                 {banks.map((bank: any) => {
//                                                     return (
//                                                         <option key={bank.id} value={bank.id}>{bank.name}</option>
//                                                     )
//                                                 })}
//                                             </select> */}
//                                             <Select 
//                                                 options={mappedBanks} 
//                                                 value={selectedBank}
//                                                 onChange={handleSelectBank}
//                                             />

//                                         </div>


//                                     </div>
//                                     <div className="d-flex justify-content-lg-end mt-4 align-items-center duo-buttons cursor-pointer">
//                                         {/* <button type="button" className="btn btn-danger btn-filled-red disabled" */}
//                                         {/* <button type="button" className={`btn btn-danger btn-filled-red ${!formik.values.otherBank ? "disabled" : ""}`}
//                                             disabled={!formik.values.otherBank} onClick={goToOtherBankReference}>Proceed</button> */}
//                                         <button type="button" className={`btn btn-danger btn-filled-red ${!selectedBank?.value ? "disabled" : ""}`}
//                                             disabled={!selectedBank?.value} onClick={goToOtherBankReference}>Proceed</button>
//                                     </div>
//                                 </div>

//                                 : ''}





//                         </div>
//                     </div>
//                     : ''}

//                 {/* ------- */}

//                 {screenToShow === 'sterling-step-one' ?
//                     <div className="p-4">
//                         <h4 className=" small-bold-texts font-weight-bold text-center mt-1">Add Reference</h4>
//                         {/* <form action=""> */}
//                         {/* <div className=" form-group sec ">
//                             <div className=" label_text pb-2 pt-4 text-left mb-1"> <label htmlFor="button">Referee's account number</label></div>
//                             <input name="sterlingAccountNumber" onInput={checkSterlingAccountNumberLength} onChange={formik.handleChange} value={formik.values.sterlingAccountNumber} type="text" className="form-control border-dark" placeholder="1234567890" />
//                             { verifyingSterlingAccount ? <small>verifying...</small> : <small>{sterlingAccountHolderName}</small>}
                            
//                         </div>
//                         <div className=" form-group sec ">
//                             <div className=" label_text pb-2 pt-4 text-left mb-1"> <label htmlFor="button">Select Bank</label></div>
//                             <input type="text" className="form-control border-dark" placeholder="Sterling Bank" disabled />
//                         </div> */}
//                         <div className=" form-group sec ">
//                             <div className=" label_text pb-2 pt-4 text-left mb-1"> <label htmlFor="button">Referee's account number</label></div>
//                             <input name="sterlingAccountNumber" onInput={checkSterlingAccountNumberLength} onChange={formik.handleChange} value={formik.values.sterlingAccountNumber} type="text" className="form-control border-dark" placeholder="1234567890" />
//                             { verifyingAccount ? <small>verifying...</small> : <small>{accountHolderName}</small>}
                            
//                         </div>
//                         <div className=" form-group sec ">
//                             <div className=" label_text pb-2 pt-4 text-left mb-1"> <label htmlFor="button">Select Bank</label></div>
//                             {
//                                 isSterlingReferee ? 
//                                 <input type="text" className="form-control border-dark" placeholder="Sterling Bank" disabled /> :
//                                 <Select 
//                                     options={mappedBanks} 
//                                     value={selectedBank}
//                                     onChange={handleSelectBank}
//                                 />
//                             }
//                         </div>
//                         {/* <div className=" success-alert2 alert alert-success alert-dismissible">
//                             <span> <img src="./images/success.png" alt="successful"/>
//                                 <h6 className="d-inline text-success font-weight-bold small pl-3">Validation Successful
//                                     and referee's consent has been confirmed!
//                                 </h6>
//                             </span>
//                             <a href="#" className="close" data-dismiss="alert" aria-label="close" id="my_alert">&times;</a>
//                         </div> */}


//                         <div className="row mx-auto text-secondary mt-5">
//                             <article className="px-0 mt-0">
//                                 <div className="text-lg-left py-2">
//                                     <span className="marker mr-1" style={{ marginRight: '10px' }}><img src={greenArrow} alt="checked" /></span>
//                                     <span>Account has been in operation for more than 6 months</span>
//                                 </div>
//                             </article>
//                             <article className=" px-0 mt-0">
//                                 <div className=" text-lg-left py-1">
//                                     <span className="marker mr-1" style={{ marginRight: '10px' }}><img src={greenArrow} alt="checked" /></span>
//                                     <span>Account is not dormant</span>
//                                 </div>
//                             </article>
//                             <article className=" px-0 mt-0">
//                                 <div className=" text-lg-left py-1">
//                                     <span className="marker mr-1" style={{ marginRight: '10px' }}><img src={greenArrow} alt="checked" /></span>
//                                     <span>Category criteria (References from an Individual account can only be used
//                                         <span className="ml-md-3">for an Individual account but a reference from a registered business is </span>
//                                         <span className="ml-md-3">suitable for all forms of current accounts).</span></span>
//                                 </div>
//                             </article>
//                         </div>

//                         {/* </form> */}

//                         <div className="d-flex justify-content-end mt-4">
//                             <div className="mb-3 mr-4" style={{ marginRight: '20px' }}>
//                                 <button className="btn btn-outline-danger mr-3 btn-filled-white">Change Referee</button>
//                             </div>

//                             {/* {updatingSterlingReferee ?
//                                 <div className="spinner-border text-danger" role="status">
//                                     <span className="sr-only"></span>
//                                 </div> :
//                                 <button type="button" disabled={!isSterlingAccountNumberValid} onClick={() => submitSterlingReferee(formik.values.sterlingAccountNumber)} className="btn btn-danger btn-filled-red">Proceed</button>
//                             } */}
//                             {/* {updatingSterlingReferee ?
//                                 <div className="spinner-border text-danger" role="status">
//                                     <span className="sr-only"></span>
//                                 </div> :
//                                 <button type="button" disabled={!isAccountNumberValid} onClick={() => submitSterlingReferee(formik.values.sterlingAccountNumber)} className="btn btn-danger btn-filled-red">Proceed</button>
//                             } */}
//                             {updatingReferee ?
//                                 <div className="spinner-border text-danger" role="status">
//                                     <span className="sr-only"></span>
//                                 </div> :
//                                 <button type="button" disabled={!isAccountNumberValid} onClick={() => submitReferee(formik.values.sterlingAccountNumber)} className="btn btn-danger btn-filled-red">Proceed</button>
//                             }
//                         </div>

//                     </div>

//                     : ''}

//                 <button type="button" id="show-modal-btn" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#reference-Added1" data-bs-whatever="@mdo">Open modal for @mdo</button>


//                 {/* ------- */}

//                 {screenToShow === 'other-bank-step-one' ?
//                     <div>
//                         <div className="p-4">
//                             <h4 className=" small-bold-texts font-weight-bold text-center mt-1">Add Reference</h4>
//                             <p className="text-center mt-3 mb-4 text-secondary pb-4">
//                                 Download or email the reference form to referee and <br />
//                                 upload the complete form. <span className="preview-text" data-toggle="modal"
//                                     data-target="#preview-reference-form">See Preview</span></p>
//                             <div className=" label_text  mt-5 text-center pb-2 mb-1"> <label htmlFor="">Share or download</label></div>
//                             <div className=" container d-flex justify-content-center pb-5">
//                                 <div className="container share-icons-tray">
//                                     <a href="#"><img src={downloadIcon} alt="download" /></a>
//                                     <a href="#"><img src={whatsappIcon} alt="share via whatsapp" /></a>
//                                     <a href="#"><img src={mailIcon} alt="share via mail" /></a>
//                                 </div>
//                             </div>
//                             <div className=" label_text  mt-5 text-center pb-2 mb-1"> <label htmlFor="">Upload completed form</label></div>

//                             <label className="cursor-pointer" htmlFor="inputTagSignature">

//                                 <div className=" container d-flex justify-content-center flex-column align-items-center">
//                                     <a><div className="ref-upload-box">

//                                         <div className="col-md drag-drop-boxes d-flex justify-content-between align-items-center p-2">
//                                             {settingReferenceForm ?
//                                                 <div className='center-v'>
//                                                     <div className="spinner-border text-danger" role="status">
//                                                         <span className="sr-only"></span>
//                                                     </div>
//                                                 </div>
//                                                 :
//                                                 <React.Fragment>
//                                                     {referenceFormName ?
//                                                         <p>{referenceFormName}</p>
//                                                         :
//                                                         <React.Fragment>

//                                                             <div className="col-8 small-light-texts px-0">Click to upload or drag <br /> and drop file</div>
//                                                             <img src={uploadIcon} alt="upload" />

//                                                         </React.Fragment>
//                                                     }
//                                                 </React.Fragment>
//                                             }
//                                         </div>

//                                     </div></a>
//                                 </div>

//                                 <input onChange={(e) => handleFileUpload(e, 'referenceForm')} id="inputTagSignature" className="input-file-type" type="file" name="file" accept="image/png, image/jpg, image/jpeg" />

//                             </label>

//                             <div className="justify-content-center  ref-upload-description pb-5">
//                                 <div className="very-small-texts px-0 m-0 col-8 mr-3">The file format should be JPEG or PDF</div>
//                             </div>

//                             <div className="d-flex justify-content-center mt-5 align-items-center duo-buttons pb-5 mb-5">
//                                 <button style={{ marginRight: '20px' }} type="button" className="btn btn-outline-danger mr-3 btn-filled-white"
//                                 >previous</button>
//                                 {updatingOtherBankReferee ?
//                                     <div className="spinner-border text-danger" role="status">
//                                         <span className="sr-only"></span>
//                                     </div> :
//                                     <button onClick={submitOtherBankReferee} type="button" className={`btn btn-danger btn-filled-red ${!referenceFormUrl ? "disabled" : ""}`} disabled={!referenceFormUrl}>Proceed</button>
//                                     // <button onClick={submitOtherBankReferee} type="button" className={`btn btn-danger btn-filled-red`}>Proceed</button>
//                                 }
//                             </div>
//                         </div>
//                     </div>
//                     : ''}


//             </form>





//             {/* ----------- */}
//             {/* <div className="modal fade reference-addedModal" id="reference-Added1" tabindex="-1" */}
//             <div className="modal fade reference-addedModal" id="reference-Added1"
//                 aria-labelledby="exampleModalLabel" aria-hidden="true">
//                 <div className="modal-dialog modal-dialog-centered">
//                     <div className="modal-content">
//                         <div className="modal-body p-5">
//                             <div className="d-flex justify-content-center">
//                                 <img src={successIcon} alt="success notification" />
//                             </div>
//                             <div className="text-center mt-3">
//                                 <p className="text-center medium-bold-texts m-2">Reference added successfully</p>
//                             </div>
//                             <p className="text-center mt-3 mb-4 text-secondary">
//                                 We have contacted your Sterling Referee, and we await their consent <br />
//                                 You will be notified if no response is received within 24hr.</p>
//                             <p className="text-center mt-3 mb-4 text-secondary">
//                                 Confirmation commences immediately after consent has been received <br />
//                                 and is completed within 1 -2 working days. <br /> You will be notified of the outcome. </p>

//                             <div className="mt-5 d-flex justify-content-center">
//                                 <button style={{ marginRight: '20px' }} type="button" className="btn btn-outline-danger mr-3 btn-filled-white"
//                                     data-bs-dismiss="modal" aria-label="Close" onClick={goToHomePage}
//                                 >okay</button>
//                                 <button type="button" className="btn btn-danger btn-filled-red2"
//                                     data-bs-dismiss="modal" aria-label="Close" onClick={addSecondReference}
//                                 >Add second reference</button>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//             {/* ----------- */}
//         </div>
//     );
// }

// export default AddReferenceCurrentDialog;